module.exports = __webpack_public_path__ + "/assets/edit_theme.png";


/*****************
 ** WEBPACK FOOTER
 ** ../src/dash/front/styles/images/edit_theme.png
 ** module id = 1063
 ** module chunks = 0
 **/